// scroll-effect
jQuery(function($) {
  // ▼scroll vari
  var _winPos;
  var _winHeight;
  var _scrollPos;
  var _scrollTimer;
  var _scrollInterval = Math.floor(1000 / 60 * 10);
  var $scrollTarget = $('.c-scroll-obj');
  var $targetTypeFade = $('.c-scroll-obj-type-fade');
  var _windowLoadedFlag = false;
  // ▼sticky vari
  // var $heroArea = $('#js-hero');
  // var $promiseArea = $('#area-promise');
  // var $businessArea = $('#area-business');
  // var $facilityArea = $('#js-facility');
  // var $companyArea = $('#area-company');
  // ▼ロード時
  // console.log('_scroll-effects');
  window.addEventListener('load', function() {
    if (!_windowLoadedFlag) {
      _winPos = $(window).scrollTop();
      _winHeight = $(window).height();
      _scrollPos = _winPos + _winHeight - 50;// 画面中央よりやや下で付与
      if ($scrollTarget.length) {
        $scrollTarget.each(function() {
          var _scrollTargetPos = $(this).offset().top;
          if (_scrollTargetPos < _scrollPos) {
            $(this).addClass('effect-is-active');
          } else {
            // $(this).removeClass('effect-is-active');
          }
        });
      }
      // スクロールイベントの発火フラグ
      _windowLoadedFlag = true;
      // console.log('window is loaded');
      // セクション重ねていく
      // _heroHeight = $(window).height();
      // $promiseArea.css('margin-top', _heroHeight);
    }
  }, false);
  setTimeout(function() {
    if (!_windowLoadedFlag) {
      _winPos = $(window).scrollTop();
      _winHeight = $(window).height();
      _scrollPos = _winPos + _winHeight - 50;// 画面中央よりやや下で付与
      if ($scrollTarget.length) {
        $scrollTarget.each(function() {
          var _scrollTargetPos = $(this).offset().top;
          if (_scrollTargetPos < _scrollPos) {
            $(this).addClass('effect-is-active');
          } else {
            // $(this).removeClass('effect-is-active');
          }
        });
      }
      // スクロールイベントの発火フラグ
      _windowLoadedFlag = true;
      // console.log('window is loaded (timeout)');
    }
  }, 3000);
  // ▼スクロール
  window.addEventListener('scroll', function() {
    if (_windowLoadedFlag) {
      // console.log('window is scrolling');
      _winPos = $(window).scrollTop();
      _winHeight = $(window).height();
      _scrollPos = _winPos + _winHeight - 50;// 画面中央よりやや下で付与
      if ($scrollTarget.length) {
        $scrollTarget.each(function() {
          var _scrollTargetPos = $(this).offset().top;
          if (_scrollTargetPos < _scrollPos) {
            $(this).addClass('effect-is-active');
          } else {
            // $(this).removeClass('effect-is-active');
          }
        });
      }
    }
  }, false);
});
